import { ReactNode } from 'react';
import styles from './Modal.module.scss';

interface ModalProps {
  onShow: boolean;
  children: ReactNode;
  className?: string;
}

const Modal = ({ children, onShow, className }: ModalProps) => {
  if (!onShow) {
    return null;
  }

  return (
    <dialog
      className={`${styles.modal} ${className}`.trim()}
      style={{ display: onShow ? 'block' : 'none' }}
    >
      {children}
    </dialog>
  );
};

export default Modal;
